$('.ts-house-component-change').on('change', function () {
    var selectedComponentId = $('#availableHouseComponents option:selected').val();
    var visibleDescriptionOptions = $('#availableMaintenanceDescriptions option').not('.hidden');
    visibleDescriptionOptions.each(function () {
        var option = $(this);
        if (option.val() !== '') {
            option.addClass('hidden');
        }
    });
    if (selectedComponentId === '') {
        $('#maintenance-description-selector').addClass('hidden');
        $('#title-element').removeClass('hidden');
        $('#title-element :input').attr('required', 'required');
        $('#description-element').removeClass('hidden');
    }
    else {
        $('#maintenance-description-selector').removeClass('hidden');
        $('#title-element').addClass('hidden');
        $('#title-element :input').removeAttr('required');
        $('#description-element').addClass('hidden');
    }
    var descriptionsToShow = $('[name=description-for-' + selectedComponentId + ']');
    if (descriptionsToShow.length > 0) {
        descriptionsToShow.each(function (index) {
            var option = $(this);
            option.removeClass('hidden');
            if (index === 0) {
                option.prop('selected', true);
            }
        });
    }
    else {
        $('#title-element').removeClass('hidden');
        $('#title-element :input').attr('required', 'required');
        $('#description-element').removeClass('hidden');
        $('#description-default-option').prop('selected', true);
        $('#maintenance-description-selector').addClass('hidden');
    }
});
$('.ts-handle-maintenance-description-change').on('change', function () {
    var selectedDescriptionId = $('#availableMaintenanceDescriptions option:selected').val();
    if (selectedDescriptionId === '') {
        $('#title-element').removeClass('hidden');
        $('#title-element :input').attr('required', 'required');
        $('#description-element').removeClass('hidden');
    }
    else {
        $('#title-element').addClass('hidden');
        $('#title-element :input').removeAttr('required');
        $('#description-element').addClass('hidden');
    }
});
jQuery(function () {
    $('.js-open-case-dialog').on('click', function () {
        $('#case-dialog').parent().addClass('visible');
    });
    //TODO: move when replacing vex
    $('#case-dialog form').submit(function (e) {
        handelPopupFormSubmit($(this));
    });
    function handelPopupFormSubmit(form) {
        var submitBtn = form.find('button[type="submit"]');
        submitBtn.prop('disabled', true);
        setTimeout(function () {
            submitBtn.prop('disabled', false);
        }, 3000);
    }
});
